module.exports = __webpack_public_path__ + "static/media/thadauro.20276ade.ogg";